import { __read } from "tslib";
import { useMemo, useReducer } from 'react';
import { DimeActionType, DimeReducer } from './../store';
export var useDimeStore = function () {
    var _a = __read(useReducer(DimeReducer, {
        convertedToPaid: undefined,
        dialogState: undefined,
    }), 2), dimeState = _a[0], dispatch = _a[1];
    var actionCreators = useMemo(function () {
        return {
            setDialogState: function (dialogState) {
                dispatch({ type: DimeActionType.setDialogState, dialogState: dialogState });
            },
            setConvertedToPaid: function (convertedToPaid) {
                dispatch({
                    type: DimeActionType.setConvertedToPaid,
                    convertedToPaid: convertedToPaid,
                });
            },
        };
    }, [dispatch]);
    return [dimeState, actionCreators];
};
//# sourceMappingURL=useDimeStore.js.map